import React from 'react';
import { useForm } from 'react-hook-form';

interface MemorySprkRecipientsItemProps {
  recipient: any;
  index: number;
  register: any;
  errors: any;
  showRemoveButton: boolean;
  setValue: Function;
  removeRecipient: Function;
};

const MemorySprkRecipientsItem: React.FC<MemorySprkRecipientsItemProps> = ({
  recipient,
  setValue,
  index,
  errors,
  showRemoveButton,
  removeRecipient,
}) => {
  const { register } = useForm({
    defaultValues: recipient,
    mode: 'onChange',
  });

  const handleChange = (e: any) => {
    setValue(`recipients.${index}.${e.target.name}`, e.target.value);
  };

  return (
    <div className="wa-cluster memory-recipients-item">
      <div className="memory-recipients-name memory-recipients-field">
        <label>Their name</label>
        <input
          type="text"
          {...register('name' as const, { required: 'Name is required', onChange: handleChange })}
          className={errors.recipients?.[index]?.name ? 'invalid' : ''}
        />
        {errors.recipients?.[index]?.name && (
          <div className="error-message">{errors.recipients[index].name.message}</div>
        )}
      </div>
      <div className="memory-recipients-email memory-recipients-field">
        <label>Their email</label>
        <input
          type="text"
          {...register('email' as const, { required: 'Email is required', onChange: handleChange })}
          className={errors.recipients?.[index]?.email ? 'invalid' : ''}
        />
        {errors.recipients?.[index]?.email && (
          <div className="error-message">{errors.recipients[index].email.message}</div>
        )}
      </div>
      <div className="memory-recipients-phone memory-recipients-field">
        <label>Their phone</label>
        <input
          type="text"
          {...register('phone' as const, { onChange: handleChange })}
        />
      </div>
      <div className="memory-recipients-remove">
        <wa-button onClick={() => removeRecipient(index)} appearance="plain" disabled={!showRemoveButton}>
          <i className="fa-solid fa-trash" />
        </wa-button>
      </div>
    </div>
  );
}

export default MemorySprkRecipientsItem;
